module.exports = __webpack_public_path__ + "media/images/app_buttons/button__appStore-1fcdabdee6f02cd6df7fdcf824a78dc4.svg";